import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b7p4sywpcz: FaireBrandEntity = {
  token: "b_b7p4sywpcz",
  type: "brand",
  name: "huemabe (All Import Duties Covered)",
  avatarUrl:
    "https://cdn.faire.com/fastly/1547abf2ae60188955b2ce16d3ce313cbdbe554aaae178a2eb15a460cdbf24a7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/275df1fa34586aee059c269d5051a906d5c119c175e0576f8bf2e5db0795c153.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1547abf2ae60188955b2ce16d3ce313cbdbe554aaae178a2eb15a460cdbf24a7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/275df1fa34586aee059c269d5051a906d5c119c175e0576f8bf2e5db0795c153.png",
  location: "GBR",
  minimumOrderDollars: 0,
  rating: 4.6,
  reviewCount: 49,
  isTopShop: true,
  isInsider: false,
  description:
    "Our story started since 2019, we are now partnering with different manufacturers worldwide to provide our customers a trustworthy product.\n\nWe started huemabe to make it easier to make informed purchases. We’re carrying the widest and funniest selection, so you could spend some time to browse to find out one thing that reflects you the most. \n\n📢 Shipping & Tariff Update\n\nWe want to reassure all of our valued customers that there will be no additional tariffs or hidden fees when ordering from our shop. We take care of all tariffs and customs duties in advance, so you can shop with confidence knowing that the price you see is the final price you pay.\n\n✅ Tariffs handled/prepaid by us – no surprise charges\n✅ Reliable delivery partners – ensuring smooth and timely shipping\n✅ No customs worries – your order arrives as usual\n\nYour shopping experience should always be simple and stress-free, and we’re committed to making sure of that.\n\n- *All our lamps are tested and certified to meet international safety and quality standards, including CE, RoHS, and FCC compliance.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.354Z",
    importedBy: "entity-db-cli",
  },
};
